import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="relative mb-10 mt-12 px-2.5 text-center md:px-3 lg:px-5">
      <div className="box mx-auto max-w-[800px] overflow-hidden bg-white dark:bg-darkPrimary md:px-[25px]">
        <div className="relative h-[130px] w-full overflow-hidden">
          <div className="header-back1"></div>
          <div className="z-10 flex h-[130px] flex-col items-center justify-center text-white">
            <h1 className="text-header z-10 mb-1">Privacy Policy</h1>
            <p className="z-10 ">Last updated: June, 2022</p>
          </div>
        </div>

        <div className="mx-3 my-8 text-left md:mx-0">
          <div>
            <p className="mb-3">
              BTI Group OÜ (“we,” “us,” or “our”), located at Tornimäe tn 3,
              Tallinn, Estonia 10145, operates the BBAScan website and provides
              blockchain exploration and analytics services for the BBAChain
              ecosystem. This Privacy Policy explains how we collect, use,
              disclose, and protect your personal information when you use our
              website and services. By accessing BBAScan, you agree to the terms
              outlined in this policy.
            </p>
            <p className="mb-3">
              For any questions or concerns, contact us at:{" "}
              <Link to="https://bbascan.com/contact"
                className="underline"
                target="_blank">
                https://bbascan.com/contact
              </Link>
              .
            </p>
          </div>

          <div className="my-3">
            <p className="mb-1 font-bold">1. Information We Collect</p>
            <p className="mb-3">
              BBAScan is designed as a blockchain analytics tool and does not
              collect personal data unless explicitly provided by users. The
              data we may collect includes:
            </p>
            <div className="ml-3">
              <p className="mb-1 font-bold">
                a. Automatically Collected Information:
              </p>
              <ul className="mb-3 ml-6 list-disc">
                <li>IP address</li>
                <li>Browser type and version</li>
                <li>Device information (e.g., operating system)</li>
                <li>
                  Usage data (e.g., pages visited, time spent on the website)
                </li>
              </ul>
            </div>
            <div className="ml-3">
              <p className="mb-1 font-bold">b. User-Provided Information:</p>
              <ul className="mb-3 ml-6 list-disc">
                <li>
                  Email address or contact details (only if you voluntarily
                  contact us).
                </li>
              </ul>
            </div>
            <div className="ml-3">
              <p className="mb-1 font-bold">c. Blockchain Data:</p>
              <p className="mb-3">
                BBAScan processes publicly available blockchain data. This data,
                such as wallet addresses, transaction details, and token
                activities, is inherently public and not considered personal
                information under this policy
              </p>
            </div>
          </div>

          <div className="my-3">
            <p className="mb-1 font-bold">
              2. How We Use Collected Information
            </p>
            <p className="mb-3">We use the collected data to:</p>
            <ul className="mb-3 ml-6 list-disc">
              <li>
                Operate, maintain, and improve the BBAScan website and services.
              </li>
              <li>
                Monitor and analyze usage patterns to enhance user experience.
              </li>
              <li>Respond to inquiries submitted via contact forms.</li>
              <li>Prevent fraud, abuse, and security threats.</li>
            </ul>
          </div>

          <div className="my-3">
            <p className="mb-1 font-bold">
              3. Sharing and Disclosure of Information
            </p>
            <p className="mb-3">
              We do not sell or share your personal data with third parties
              unless required for the operation of our services or mandated by
              law. Circumstances where information may be shared include:
            </p>
            <ul className="mb-3 ml-6 list-disc">
              <li>
                <span className="font-bold">Service Providers</span>: Trusted
                third-party vendors assisting in website operation and
                analytics.
              </li>
              <li>
                <span className="font-bold">Legal Requirements</span>:
                Compliance with applicable laws, regulations, or legal
                processes.
              </li>
            </ul>
            <p className="mb-3">
              Blockchain data accessed through BBAScan remains publicly
              available and is not controlled by us.{" "}
            </p>
          </div>

          <div className="my-3">
            <p className="mb-1 font-bold">
              4. Cookies and Tracking Technologies
            </p>
            <p className="mb-3">
              BBAScan uses cookies and similar tracking technologies to enhance
              functionality and analyze website usage. You can manage or disable
              cookies through your browser settings, but this may affect the
              website's performance.
            </p>
          </div>

          <div className="my-3">
            <p className="mb-1 font-bold">5. Data Security</p>
            <p className="mb-3">
              We prioritize the security of your data and employ
              industry-standard measures to safeguard it. However, no method of
              transmission or storage is entirely secure, and we cannot
              guarantee absolute protection.
            </p>
          </div>

          <div className="my-3">
            <p className="mb-1 font-bold">6. Retention of Data</p>
            <p className="mb-3">
              We retain automatically collected data for as long as necessary to
              fulfill the purposes outlined in this Privacy Policy. Contact
              information provided by users is retained only as long as needed
              to address inquiries or comply with legal obligations.
            </p>
          </div>

          <div className="my-3">
            <p className="mb-1 font-bold">7. User Rights</p>
            <p className="mb-3">As a user, you have the right to:</p>
            <ul className="mb-3 ml-6 list-disc">
              <li>
                Request access to any personal data you have provided to us.
              </li>
              <li>Request corrections or deletion of your personal data.</li>
              <li>Opt out of cookies or tracking technologies.</li>
            </ul>
            <p className="mb-3">
              To exercise these rights, contact us at:{" "}
              <Link
                to="https://bbascan.com/contact"
                className="underline"
                target="_blank"
              >
                https://bbascan.com/contact
              </Link>
              .
            </p>
          </div>

          <div className="my-3">
            <p className="mb-1 font-bold">8. Third-Party Links</p>
            <p className="mb-3">
              BBAScan may include links to third-party websites or services. We
              are not responsible for the privacy practices or content of these
              third parties. We encourage users to review the privacy policies
              of external sites.
            </p>
          </div>

          <div className="my-3">
            <p className="mb-1 font-bold">9. Children’s Privacy</p>
            <p className="mb-3">
              BBAScan is not directed at children under the age of 18. We do not
              knowingly collect personal information from minors.
            </p>
          </div>

          <div className="my-3">
            <p className="mb-1 font-bold">10. Updates to the Privacy Policy</p>
            <p className="mb-3">
              We may update this Privacy Policy periodically to reflect changes
              in our practices or applicable regulations. Updates will be posted
              on this page, and continued use of BBAScan constitutes acceptance
              of the revised terms.
            </p>
          </div>

          <div className="my-3">
            <p className="mb-1 font-bold">11. Governing Law</p>
            <p className="mb-3">
              This Privacy Policy is governed by the laws of Estonia. Any
              disputes will be resolved under the jurisdiction of the courts in
              Tallinn, Estonia.
            </p>
          </div>

          <div className="my-3">
            <p className="mb-1 font-bold">12. Contact Us</p>
            <p className="mb-3">
              For further inquiries or concerns regarding this Privacy Policy,
              please reach out to us:{" "}
              <Link
                to="https://bbascan.com/contact"
                className="underline"
                target="_blank"
              >
                https://bbascan.com/contact
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
